<template>
  <div tabindex="0" @keyup="emmitClick" @click="emmitClick">
    <div
      v-if="!companySelectModalState"
      class="hoverPointer"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="72"
        height="60"
        viewBox="0 0 72 60"
      >
        <g
          fill="none"
          fill-rule="evenodd"
        >
          <path
            fill="#323C44"
            d="M0 0h72v60H0z"
          />
          <path
            fill="#FFF"
            transform="translate(25, 17)"
            data-v-2a9942c2=""
            d="M6 7h12v2H6zM6 11h12v2H6zM6 15h12v2H6z"
          />
        </g>
      </svg>
    </div>

    <div
      v-if="companySelectModalState"
      class="hoverPointer"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="72"
        height="60"
        viewBox="0 0 72 60"
      >
        <g
          fill="none"
          fill-rule="evenodd"
        >
          <path
            fill="#FFF"
            d="M0 0h72v60H0z"
          />
          <!-- eslint-disable-next-line -->
          <path fill="#323C44" d="M43 24.41L41.59 23 36 28.59 30.41 23 29 24.41 34.59 30 29 35.59 30.41 37 36 31.41 41.59 37 43 35.59 37.41 30z"/>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RareHamburgerIcon',
  data() {
    return {
    };
  },
  computed: {
    companySelectModalState() {
      return this.$store.getters.companySelectModalState;
    },
  },
  methods: {
    emmitClick() {
      this.$store.commit('updateCompanySelectModalState', !this.companySelectModalState);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@/css/global.scss";
  .hoverPointer {
    cursor: pointer;
  }
</style>
